// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"ed293b4c","130":"8dad0977","488":"615d0b93","844":"2e92a240","871":"72c76995","882":"c1944065","929":"991d9ce3"}[chunkId] + ".chunk.js";
};